module.exports = __webpack_public_path__ + "static/media/instagram.636247c4.svg";